module.exports = __webpack_public_path__ + "assets/5d60154f2bd9250a59aed7e66d9c3c42.svg";